import { AxiosError } from 'axios';
import instance from '../config/axios';

export const getWishListForPatient = async (token: string) => {
  try {
    const response = await instance.get('/api/v1/fetch/whislists', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    console.error(err);
    return (err as AxiosError).response?.status as number;
  }
};
